import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './CustomTooltip.module.scss';

const CustomTooltip = ({ active, payload }) => {
  if (
    active &&
    payload &&
    payload[0].payload &&
    payload[0].payload.fill !== '#dde6f2'
  ) {
    return (
      <div className={classes.box}>
        <Text type="p" className={classes.item}>
          <img
            alt=""
            className={classes.square}
            style={{ backgroundColor: payload[0].payload.fill }}
          ></img>
          <Text className={classes.name}>{payload[0].name}</Text>
          <Text
            className={classes.text}
          >{`${payload[0].value} from ${payload[0].payload.weight}`}</Text>
        </Text>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  payload: PropTypes.arrayOf(object),
  active: PropTypes.bool
};

export default CustomTooltip;
